import { useNonce, CF_URL } from './use-nonce'
import * as React from 'react'

export function useAjaxWp<ResponseData>(action: string, nonceType: string) {
  const { getNonce } = useNonce()
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)
  const [data, setData] = React.useState<ResponseData | null>(null)

  const query = async (
    formParams: Record<string, string>,
    {
      onSuccess,
      onError,
    }: { onSuccess?: (data: ResponseData) => void; onError?: (error: string) => void },
  ) => {
    setLoading(true)
    setError(null)

    try {
      const nonce = await getNonce(nonceType)
      const params = new URLSearchParams()
      params.append('action', action)
      params.append('security', nonce)

      Object.entries(formParams).forEach(([key, value]) => {
        params.append(key, value)
      })

      const res = await fetch(`${CF_URL}/wp-admin/admin-ajax.php`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        body: params.toString(),
      })

      // oxlint-disable-next-line no-negated-condition
      if (!res.ok) {
        setError(res.statusText)
        onError?.(res.statusText)
      } else {
        const data = await res.json()

        setData(data as ResponseData)
        onSuccess?.(data as ResponseData)
      }
      // oxlint-disable-next-line unicorn/catch-error-name
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to submit form')
      onError?.(err instanceof Error ? err.message : 'Failed to submit form')
    }

    setLoading(false)
  }

  return { query, loading, error, data }
}
